module.exports = new __parcel__URL__("seal_select.44d7a47f.mp3").toString();